<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>合作伙伴</h1>
        <div class="sub">携手共建全球化出海服务生态</div>
      </div>
    </div>
    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div class="partner-grid" v-if="rows.length">
          <div class="partner-item" v-for="p in rows" :key="p.id">
            <img v-if="p.icon" :src="p.icon" :alt="p.title" @error="onImgError" />
            <span v-else class="partner-ph">{{ p.title.slice(0, 1) }}</span>
            <span class="partner-name">{{ p.title }}</span>
          </div>
        </div>

        <div class="empty-block" v-else-if="!loading">暂无合作伙伴</div>
        <div class="empty-block" v-else>加载中…</div>

        <div class="pager" v-if="totalPages > 1">
          <button class="pg-btn" :disabled="pageNum <= 1" @click="goPage(pageNum - 1)">‹ 上一页</button>
          <button
            v-for="p in pages"
            :key="p"
            class="pg-num"
            :class="{ active: p === pageNum }"
            @click="goPage(p)"
          >{{ p }}</button>
          <button class="pg-btn" :disabled="pageNum >= totalPages" @click="goPage(pageNum + 1)">下一页 ›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchFriendLinks } from '../api/home'

export default {
  name: 'PartnersList',
  data () {
    return {
      rows: [],
      pageNum: 1,
      pageSize: 12,
      total: 0,
      loading: true
    }
  },
  computed: {
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pages () {
      const tp = this.totalPages
      const cur = this.pageNum
      if (tp <= 7) return Array.from({ length: tp }, (_, i) => i + 1)
      const set = new Set([1, tp, cur, cur - 1, cur + 1, cur - 2, cur + 2])
      const arr = [...set].filter(p => p >= 1 && p <= tp).sort((a, b) => a - b)
      const out = []
      let prev = 0
      for (const p of arr) {
        if (p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      }
      return out
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const res = await fetchFriendLinks({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          status: '0'
        })
        this.rows = res.rows
        this.total = res.total
      } catch (e) {
        this.rows = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    goPage (p) {
      if (p < 1 || p > this.totalPages || p === this.pageNum) return
      this.pageNum = p
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.partner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 22px;
}
.partner-item {
  background: #fff;
  border: 1px solid var(--border, #e6ebf5);
  border-radius: 14px;
  box-shadow: var(--shadow, 0 6px 22px rgba(36, 68, 203, 0.08));
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.partner-item:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-hover, 0 12px 30px rgba(36, 68, 203, 0.16));
}
.partner-item img {
  width: 100%;
  height: 140px;
  object-fit: contain;
  object-position: center;
  padding: 16px;
  box-sizing: border-box;
  display: block;
  background: #fff;
}
.partner-ph {
  width: 100%;
  height: 140px;
  background: var(--primary, #2444cb);
  color: #fff;
  font-size: 40px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-main, #33415c);
  text-align: center;
  padding: 14px 12px 18px;
}
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.pg-btn,
.pg-num {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border, #e6ebf5);
  background: #fff;
  color: var(--text-main, #33415c);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pg-btn:hover:not(:disabled),
.pg-num:hover {
  border-color: var(--primary, #2444cb);
  color: var(--primary, #2444cb);
}
.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.pg-num.active {
  background: var(--primary, #2444cb);
  border-color: var(--primary, #2444cb);
  color: #fff;
}
.pager :not(button) {
  color: var(--text-sub, #9aa6c0);
  padding: 0 4px;
}
.empty-block {
  text-align: center;
  color: var(--text-sub, #9aa6c0);
  padding: 40px 0;
}
</style>
